import { render, staticRenderFns } from "./TgDialog.vue?vue&type=template&id=27a8a573"
import script from "./TgDialog.vue?vue&type=script&lang=js"
export * from "./TgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports